var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GoogleBtn',_vm._g(_vm._b({attrs:{"disabled":_vm.isAuthorizing},on:{"click":function($event){$event.preventDefault();return _vm.authorize.apply(null, arguments)}}},'GoogleBtn',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }